import { Model, Attribute } from "@datx/core";

export default class LoadStatus extends Model {
  static type = "loadStatus";
}

Attribute()(LoadStatus, "name");
Attribute({ defaultValue: false })(LoadStatus, "loaded");
Attribute({ defaultValue: false })(LoadStatus, "loading");
